import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import './scss/index.scss';
import App from './App';
import {PublicClientApplication} from '@azure/msal-browser';
import {msalConfig} from './services/auth-provider';
import * as serviceWorker from './serviceWorker';
import {store} from './store/store';
import {Provider} from 'react-redux';

export const msalInstance = new PublicClientApplication(msalConfig);


ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App pca={msalInstance} />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
